import { PropsWithChildren, ReactNode } from "react";
import { cn } from "@/lib/utils";
import { Flex, IconButton } from "@radix-ui/themes";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { InfoCircledIcon } from "@radix-ui/react-icons";
import { Tooltip } from "@/components/shared/tooltip";
import {
  LinkToExplorePage,
  LinkToExplorePageProps,
} from "@/v2/features/home/LinkToExplorePage";

interface HomePageCardProps {
  linkProps?: LinkToExplorePageProps;
  tooltip?: ReactNode;
  actions?: ReactNode;
  classes?: {
    card?: string;
    cardHeader?: string;
    cardTitle?: string;
    cardContent?: string;
  };
}

export function HomePageCard({
  linkProps,
  tooltip,
  children,
  actions,
  classes = {},
}: PropsWithChildren<HomePageCardProps>) {
  const hasHeader = linkProps != null || tooltip != null || actions != null;

  return (
    <Card className={cn("h-full flex flex-col", classes.card)}>
      {hasHeader && (
        <CardHeader className={classes.cardHeader}>
          <CardTitle
            className={cn(
              "flex gap-1",
              classes.cardTitle,
              linkProps != null && "justify-between",
              linkProps == null && "justify-end"
            )}
          >
            {linkProps != null && <LinkToExplorePage {...linkProps} />}

            {(tooltip != null || actions != null) && (
              <Flex gap={"1"} align="center">
                {tooltip != null && (
                  <Tooltip>
                    <Tooltip.Trigger>
                      <IconButton variant="soft" size="2" color="gray">
                        <InfoCircledIcon height={16} width={16} />
                      </IconButton>
                    </Tooltip.Trigger>

                    <Tooltip.Content>{tooltip}</Tooltip.Content>
                  </Tooltip>
                )}

                {actions != null && actions}
              </Flex>
            )}
          </CardTitle>
        </CardHeader>
      )}

      <CardContent className={cn("flex-1", classes.cardContent)}>
        {children}
      </CardContent>
    </Card>
  );
}
